import { KeycloakAccountClient } from './accountClient.mjs';
import { KeycloakClient } from './client.mjs';
export const resolveEmailAuthMethod = (keycloakConfig, email, captcha) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.resolveEmailAuthMethod(email, captcha);
};
export const resolvePhoneAuthMethod = (keycloakConfig, phone, captcha) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.resolvePhoneAuthMethod(phone, captcha);
};
export const sendEmailLink = (keycloakConfig, options) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.sendEmailLink(options);
};
export const sendEmailCode = (keycloakConfig, options) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.sendEmailCode(options);
};
export const resendEmailCode = (keycloakConfig, email, token, captcha) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.resendEmailCode(email, token, captcha);
};
export const sendPhoneCode = (keycloakConfig, options) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.sendPhoneCode(options);
};
export const resendPhoneCode = (keycloakConfig, phoneNumber, sendMethod, token, captcha) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.resendPhoneCode(phoneNumber, sendMethod, token, captcha);
};
export const emailPasswordGrant = (keycloakConfig, email, password) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.emailPasswordGrant(email, password);
};
export const emailCodeGrant = (keycloakConfig, email, token, code, password) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.emailCodeGrant(email, token, code, password);
};
export const phonePasswordGrant = (keycloakConfig, phone, password) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.phonePasswordGrant(phone, password);
};
export const phoneCodeGrant = (keycloakConfig, phoneNumber, token, code, password) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.phoneCodeGrant(phoneNumber, token, code, password);
};
export const refreshGrant = (keycloakConfig, refreshToken) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.refreshGrant(refreshToken);
};
export const authorizationCodeGrant = (keycloakConfig, authorizationCode, redirectURI) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.authorizationCodeGrant(authorizationCode, redirectURI);
};
export const tokenExchangeGrant = (keycloakConfig, provider, token, subjectTokenType, redirectURI) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.tokenExchangeGrant(provider, token, subjectTokenType, redirectURI);
};
export const revokeGrant = (keycloakConfig, refreshToken) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.revokeGrant(refreshToken);
};
export const createLoginURL = (keycloakConfig, params) => {
    const client = new KeycloakClient(keycloakConfig);
    return client.createLoginURL(params);
};
export const changePassword = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.changePassword(payload);
};
export const changePhone = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.changePhone(payload);
};
export const addAdditionalPhone = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.addAdditionalPhone(payload);
};
export const resendChangePhoneChallengeCode = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.resendChangePhoneChallengeCode(payload);
};
export const resendAddAdditionalPhoneChallengeCode = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.resendAddAdditionalPhoneChallengeCode(payload);
};
export const completeChangePhoneChallenge = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.completeChangePhoneChallenge(payload);
};
export const completeAddAdditionalPhoneChallenge = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.completeAddAdditionalPhoneChallenge(payload);
};
export const getFirebaseToken = (keycloakConfig, accessToken) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.getFirebaseToken(accessToken);
};
export const addUnverifiedEmail = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.addUnverifiedEmail(payload);
};
export const startChangeEmailChallenge = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.startChangeEmailChallenge(payload);
};
export const resendChangeEmailChallengeCode = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.resendChangeEmailChallengeCode(payload);
};
export const completeChangeEmailChallenge = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.completeChangeEmailChallenge(payload);
};
export const updateUserProfile = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.updateUserProfile(payload);
};
export const linkIdentityProvider = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.linkIdentityProvider(payload);
};
export const unlinkIdentityProvider = (keycloakConfig, payload) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.unlinkIdentityProvider(payload);
};
export const deactivateUser = (keycloakConfig, accessToken) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.deactivateUser(accessToken);
};
export const reserveUserByEmail = (keycloakConfig, email, captcha) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.reserveUserByEmail(email, captcha);
};
export const getSessionCompleteUserProfile = (keycloakConfig, accessToken) => {
    const client = new KeycloakAccountClient(keycloakConfig);
    return client.getSessionCompleteUserProfile({ accessToken });
};
